import React, { ReactNode } from 'react';
import { Button as MaterialButton } from '@material-ui/core';

import { useStyles } from './Button.styles';
import { Color, Size, Variant } from '../../types';

export interface Props {
  size?: Size;
  variant?: Variant;
  children?: ReactNode;
  disabled?: boolean;
  color?: Color;
  qaId?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  startIcon?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}

const Button: React.FC<Props> = ({
  children,
  variant = 'contained',
  size = 'medium',
  disabled,
  color = 'primary',
  qaId,
  onClick,
  startIcon,
  type = 'button',
  className,
}: Props) => {
  const classes = useStyles();

  return (
    <MaterialButton
      classes={{
        root: classes.root,
        sizeLarge: classes.sizeLarge,
        sizeSmall: classes.sizeSmall,
        label: classes.label,
        containedPrimary: classes.containedPrimary,
        containedSecondary: classes.containedSecondary,
        outlinedPrimary: classes.outlinedPrimary,
        textPrimary: classes.textPrimary,
        disabled: classes.disabled,
      }}
      variant={variant}
      size={size}
      disableRipple={true}
      disabled={disabled}
      color={color}
      data-qa-id={qaId}
      disableElevation={true}
      onClick={onClick}
      startIcon={startIcon}
      onMouseDown={(e) => e.preventDefault()}
      type={type}
      className={className}
    >
      {children}
    </MaterialButton>
  );
};

export default Button;
